export default {
  adminGestion: {
    title: 'CRM Gestion',
    selectCountry: 'Sélectionner un pays',
    noCountries: 'Aucun pays disponible. Veuillez contacter un administrateur.',
    nav: {
      dashboard: 'Dashboard',
      groups: 'Groupes',
      facilities: 'Établissements',
      redaction: 'Rédaction',
      dossiers: 'Dossiers',
      blog: 'Blog'
    },
    stats: {
      facilities: 'Établissements',
      groups: 'Groupes',
      leads: 'Prospects'
    },
    groups: {
      title: 'Gestion des Groupes',
      search: 'Rechercher un groupe...',
      columns: {
        logo: 'Logo',
        name: 'Nom',
        facilities: 'Établissements',
        users: 'Utilisateurs'
      },
      contact: {
        title: 'Contact Principal',
        firstName: 'Prénom',
        lastName: 'Nom',
        email: 'Email',
        phone: 'Téléphone',
        address: 'Adresse',
        postalCode: 'Code postal',
        city: 'Ville',
        edit: 'Modifier le contact',
        save: 'Enregistrer',
        cancel: 'Annuler'
      },
      users: {
        title: 'Gestion des Utilisateurs',
        add: 'Ajouter un utilisateur',
        email: 'Email',
        password: 'Mot de passe',
        passwordOptional: 'optionnel - laisser vide pour ne pas modifier',
        passwordPlaceholder: 'Laisser vide pour conserver le mot de passe actuel',
        generate: 'Générer',
        fullName: 'Nom complet',
        role: 'Rôle',
        roles: {
          groupUser: 'Utilisateur du groupe',
          facilityUser: 'Utilisateur d\'établissement'
        },
        defaultLanguage: 'Langue par défaut',
        languageHint: 'Choisissez parmi les langues disponibles dans les pays du groupe',
        cancel: 'Annuler',
        create: 'Créer l\'utilisateur',
        update: 'Mettre à jour',
        saving: 'Enregistrement...',
        edit: 'Modifier',
        remove: 'Supprimer'
      },
      actions: {
        manageUsers: 'Gérer les utilisateurs',
        editContact: 'Modifier le contact'
      }
    },
    facilities: {
      title: 'Établissements',
      search: 'Rechercher un établissement...',
      allGroups: 'Tous les groupes',
      allTypes: 'Tous les types',
      columns: {
        name: 'Nom',
        types: 'Types',
        location: 'Localisation',
        group: 'Groupe',
        paying: 'Payant'
      },
      actions: {
        edit: 'Modifier'
      },
      pagination: {
        show: 'Afficher',
        showing: '{from}-{to} sur {total} établissements',
        previous: 'Précédent',
        next: 'Suivant',
        to: 'à',
        of: 'sur',
        results: 'résultats'
      },
      add: {
        title: 'Ajouter un établissement',
        name: 'Nom',
        description: 'Description',
        address: 'Adresse',
        city: 'Ville',
        postalCode: 'Code postal',
        latitude: 'Latitude',
        longitude: 'Longitude',
        nationalId: 'Identifiant national (FINESS)',
        types: 'Types d\'établissement',
        typesHint: 'Maintenez Ctrl/Cmd pour sélectionner plusieurs types',
        geoEntity: 'Zone géographique',
        selectGeoEntity: 'Sélectionner une zone géographique',
        group: 'Groupe',
        noGroup: 'Aucun groupe',
        phone: 'Téléphone',
        email: 'Email',
        website: 'Site web',
        cancel: 'Annuler',
        create: 'Créer l\'établissement',
        creating: 'Création en cours...',
        button: 'Ajouter un établissement',
        trigrame:'Trigrame',
        type:'Type',
        typePrive:'Privé',
        typePriveNL:'Privé Non lucratif',
        typePublic:'Publique',
        
      },
      edit: {
        title: 'Modifier l\'établissement',
        save: 'Enregistrer les modifications',
        saving: 'Enregistrement en cours...'
      },
      details: {
        title: 'Détails de l\'établissement',
        info: {
          title: 'Informations',
          subtitle: 'Informations générales sur l\'établissement',
          name: 'Nom',
          types: 'Types',
          group: 'Groupe',
          noGroup: 'Aucun groupe',
          contact: 'Contact',
          description: 'Description',
          trafficStats: 'Statistiques de trafic',
          trafficStatsDescription: 'Aperçu des visites sur votre page d\'établissement',
          dateStart: 'Date de début',
          dateEnd: 'Date de fin',
          granularity: 'Granularité',
          day: 'Jour',
          week: 'Semaine',
          month: 'Mois',
          noTrafficData: 'Aucune donnée disponible pour la période sélectionnée'
        },
        users: {
          title: 'Utilisateurs',
          subtitle: 'Gestionnaires de l\'établissement',
          fullName: 'Nom complet',
          email: 'Email',
          createdAt: 'Date de création',
          password: 'Mot de passe',
          passwordOptional: 'Optionnel - laisser vide pour ne pas modifier',
          passwordPlaceholder: 'Laisser vide pour conserver le mot de passe actuel',
          defaultLanguage: 'Langue par défaut',
          generate: 'Générer',
          addUser: 'Ajouter un utilisateur',
          editUser: 'Modifier l\'utilisateur',
          emailNoEdit: 'L\'email ne peut pas être modifié',
          noUsers: 'Aucun utilisateur pour cet établissement',
          addFirstUser: 'Ajouter un premier utilisateur',
          confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
          validation: {
            requiredFields: 'Le nom et l\'email sont requis',
            passwordRequired: 'Le mot de passe est requis pour un nouvel utilisateur'
          }
        },
        contacts: {
          title: 'Contacts',
          subtitle: 'Liste des contacts de l\'établissement',
          noContacts: 'Aucun contact',
          add: 'Ajouter un contact',
          edit: 'Modifier',
          delete: 'Supprimer',
          form: {
            title: 'Contact',
            role: 'Fonction',
            selectRole:'Sélectionner une fonction',
            name: 'Nom',
            phone: 'Téléphone',
            mobile: 'Téléphone mobile',
            email: 'Email',
            save: 'Enregistrer',
            cancel: 'Annuler',
            saving: 'Enregistrement...',
            roleList:{
              role1:'Directeur',
              role2:'Secrétaire',
              role3:'Assistante de direction',
              role4:'Conseiller commercial',
              role5:'Directeur Régional',
              role6:'Autre'
            }
          }
        },
        features: {
          title: 'Caractéristiques',
          subtitle: 'Caractéristiques spécifiques de l\'établissement',
          noFeatures: 'Aucune caractéristique configurée'
        },
        timeline: {
          title: 'Historique',
          subtitle: 'Historique des modifications',
          noEvents: 'Aucun événement',
          unknownUser: 'Utilisateur inconnu'
        },
        housing: {
          title: 'Hébergements',
          subtitle: 'Types d\'hébergement disponibles',
          noUnits: 'Aucun hébergement configuré',
          add: 'Ajouter un hébergement',
          edit: 'Modifier',
          delete: 'Supprimer',
          type: 'Type',
          units: 'Nombre',
          area: 'Surface (m²)',
          price: 'Prix/mois',
          form: {
            title: 'Hébergement',
            type: 'Type',
            units: 'Nombre d\'unités',
            area: 'Surface (m²)',
            price: 'Prix par mois',
            pricePerDay: 'Prix par jour',
            priceConversionNote: 'Prix journalier × 30 = Prix mensuel',
            currency: 'Devise',
            notes: 'Notes',
            save: 'Enregistrer',
            cancel: 'Annuler',
            saving: 'Enregistrement...',
            multiAdd: 'Ajouter plusieurs types',
            selectTypes: 'Sélectionner les types',
            typesSelected: 'type(s) sélectionné(s)',
            addAnother: 'Ajouter un de +'
          }
        },
        media: {
          title: 'Photos et Vidéos',
          subtitle: 'Médias de l\'établissement',
          noMedia: 'Aucun média',
          add: 'Ajouter un ou plusieurs médias',
          dragDrop:'Glissez un ou plusieurs médias ici',
          edit: 'Modifier',
          delete: 'Supprimer',
          upload: 'Télécharger',
          form: {
            title: 'Média',
            type: 'Type',
            file: 'Fichier',
            alt: 'Texte alternatif',
            save: 'Enregistrer',
            cancel: 'Annuler',
            saving: 'Enregistrement...'
          },
          types: {
            photo: 'Photo',
            exterior: 'Extérieur',
            interior: 'Intérieur',
            room: 'Chambre',
            dining: 'Salle à manger',
            common: 'Espace commun',
            video: 'Vidéo'
          }
        },
        documents: {
          title: 'Brochures',
          subtitle: 'Documents de l\'établissement',
          noDocuments: 'Aucun document',
          add: 'Ajouter un document',
          upload: 'Télécharger',
          view: 'Voir',
          delete: 'Supprimer',
          form: {
            title: 'Document',
            type: 'Type',
            file: 'Fichier',
            name: 'Nom',
            save: 'Enregistrer',
            cancel: 'Annuler',
            saving: 'Enregistrement...'
          }
        }
      },
      name: 'Nom',
      type: 'Type',
      location: 'Localisation',
      view: 'Voir',
      list: 'Liste des établissements',
      loading: 'Chargement des établissements...',
      noFacilities: 'Aucun établissement trouvé',
      show: 'Afficher',
      to: 'à',
      of: 'sur',
      results: 'résultats',
      previous: 'Précédent',
      next: 'Suivant',
      viewPublicPage: 'Voir la page publique',
      establishmentsUnit: 'établissements',
      searchPlaceholder: 'Rechercher par nom, ville ou département...'
    },
    redaction: {
      dossiers: {
        title: 'Gestion des Dossiers',
        categories: {
          title: 'Catégories',
          add: 'Ajouter une catégorie',
          edit: 'Modifier la catégorie',
          name: 'Nom',
          slug: 'Slug',
          description: 'Description',
          parent: 'Catégorie parent',
          noParent: 'Aucune catégorie parent',
          position: 'Position',
          active: 'Active',
          image: 'Image',
          noCategories: 'Aucune catégorie',
          confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette catégorie ?'
        },
        articles: {
          title: 'Articles',
          add: 'Nouveau dossier',
          edit: 'Modifier le dossier',
          list: 'Liste des dossiers',
          allArticles: 'Tous les dossiers',
          title_field: 'Titre',
          slug: 'Slug',
          excerpt: 'Extrait',
          content: 'Contenu',
          category: 'Catégorie',
          selectCategory: 'Sélectionner une catégorie',
          seoTitle: 'Titre SEO',
          seoDescription: 'Description SEO',
          image: 'Image',
          published: 'Publié',
          publishedAt: 'Date de publication',
          author: 'Auteur',
          viewCount: 'Vues',
          noArticles: 'Aucun dossier',
          confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce dossier ?',
          draft: 'Brouillon',
          publish: 'Publier'
        }
      },
      blog: {
        title: 'Gestion du Blog',
        categories: {
          title: 'Catégories',
          add: 'Ajouter une catégorie',
          edit: 'Modifier la catégorie',
          name: 'Nom',
          slug: 'Slug',
          description: 'Description',
          parent: 'Catégorie parent',
          noParent: 'Aucune catégorie parent',
          position: 'Position',
          active: 'Active',
          image: 'Image',
          noCategories: 'Aucune catégorie',
          confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette catégorie ?'
        },
        articles: {
          title: 'Articles',
          add: 'Nouvel article',
          edit: 'Modifier l\'article',
          list: 'Liste des articles',
          allArticles: 'Tous les articles',
          title_field: 'Titre',
          slug: 'Slug',
          excerpt: 'Extrait',
          content: 'Contenu',
          category: 'Catégorie',
          selectCategory: 'Sélectionner une catégorie',
          seoTitle: 'Titre SEO',
          seoDescription: 'Description SEO',
          image: 'Image',
          published: 'Publié',
          publishedAt: 'Date de publication',
          author: 'Auteur',
          viewCount: 'Vues',
          noArticles: 'Aucun article',
          confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet article ?',
          draft: 'Brouillon',
          publish: 'Publier'
        }
      }
    }
  },
  adminConfig: {
    leadForms: {
      title: 'Gestion des formulaires de leads',
      description: 'Gérez les formulaires de leads par pays et créez des étapes et des champs personnalisés.',
      selectCountry: 'Sélectionner un pays',
      selectCountryPrompt: 'Sélectionner un pays',
      formList: 'Liste des formulaires',
      createNew: 'Créer un nouveau formulaire',
      createFormTitle: 'Créer un nouveau formulaire',
      noForms: 'Aucun formulaire pour ce pays. Créez-en un nouveau.',
      form: {
        name: 'Nom',
        slug: 'Slug',
        slugHelp: 'Identifiant unique pour ce formulaire (utilisé dans les URLs)',
        description: 'Description'
      },
      steps: {
        title: 'Étapes',
        list: 'Liste des étapes',
        add: 'Ajouter une étape',
        create: 'Créer une étape',
        name: 'Nom de l\'étape',
        enableLoader: 'Activer le chargeur personnalisé',
        loaderHtml: 'HTML du chargeur',
        loaderHtmlHelp: 'Code HTML affiché pendant le chargement de cette étape',
        hasLoader: 'Cette étape possède un chargeur personnalisé',
        confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette étape ? Les champs associés seront conservés mais détachés de l\'étape.',
        noSteps: 'Aucune étape pour ce formulaire. Créez-en une nouvelle.'
      },
      fields: {
        title: 'Champs',
        global: 'Champs globaux',
        addGlobal: 'Ajouter un champ global',
        stepFields: 'Champs pour l\'étape : {name}',
        addToStep: 'Ajouter un champ',
        noGlobalFields: 'Aucun champ global. Ajoutez-en un nouveau.',
        noStepFields: 'Aucun champ pour cette étape. Ajoutez-en un nouveau.',
        add: 'Ajouter un champ',
        edit: 'Modifier le champ',
        hasOptions: 'Avec options',
        confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce champ ?',
        types: {
          text: 'Texte',
          email: 'Email',
          tel: 'Téléphone',
          number: 'Nombre',
          boolean: 'Oui/Non',
          checkbox: 'Checkbox',
          selectBouton: 'Sélection forme bouton',
          select: 'Sélection',
          date: 'Date',
          department: 'Département',
          department_city: 'Département + Ville'
        },
        form: {
          label: 'Libellé',
          type: 'Type',
          step: 'Étape',
          noStep: 'Champ global (hors étape)',
          options: 'Options',
          optionPlaceholder: 'Valeur de l\'option',
          addOption: 'Ajouter une option'
        }
      }
    }
  },
  common: {
    yes: 'Oui',
    no: 'Non',
    edit: 'Modifier',
    back: 'Retour',
    add: 'Ajouter',
    select:'Sélectionner',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    cancel: 'Annuler',
    loading: 'Chargement...',
    signOut: 'Déconnexion',
    close: 'Fermer',
    delete: 'Supprimer',
    remove: 'Supprimer',
    or: 'ou',
    upTo: 'jusqu\'à',
    selectLeadPrompt: 'Sélectionnez une demande pour voir les détails.',
    modify: 'Modifier',
    create: 'Créer',
    ok: 'OK'
  },
  validation: {
    required: 'Ce champ est requis',
    uniqueSlug: 'Ce slug est déjà utilisé dans ce pays'
  },
  errors: {
    fileTooLarge: 'Le fichier est trop volumineux (maximum {size})',
    fileTypeNotAllowed: 'Ce type de fichier n\'est pas autorisé',
    fileRequired: 'Veuillez sélectionner un fichier',
    uploadFailed: 'Le téléchargement a échoué'
  },
  facility: {
    title: 'Établissement',
    user: 'Utilisateur',
    manager: 'Gestionnaire d\'établissement',
    facilityManager: 'Gestionnaire d\'établissement',
    nav: {
      dashboard: 'Tableau de bord',
      info: 'Informations',
      contacts: 'Contacts',
      housing: 'Hébergement',
      features: 'Caractéristiques',
      media: 'Médias',
      documents: 'Brochures',
      leads: 'Prospects'
    },
    info: {
      title: 'Informations de l\'établissement',
      name: 'Nom',
      address: 'Adresse',
      city: 'Ville',
      postalCode: 'Code postal',
      phone: 'Téléphone',
      email: 'Email',
      website: 'Site web',
      description: 'Description',
      type: 'Type d\'établissement',
      group: 'Groupe',
      edit: 'Modifier',
      save: 'Enregistrer',
      cancel: 'Annuler',
      updated: 'Informations mises à jour',
      trafficStats: 'Statistiques de trafic',
      trafficStatsDescription: 'Aperçu des visites sur votre page d\'établissement',
      dateStart: 'Date de début',
      dateEnd: 'Date de fin',
      granularity: 'Granularité',
      day: 'Jour',
      week: 'Semaine',
      month: 'Mois',
      noTrafficData: 'Aucune donnée disponible pour la période sélectionnée'
    },
    dashboard: {
      totalLeads: 'Total des prospects',
      newLeads: 'Nouveaux prospects',
      reviews: 'Avis',
      trafficStats: 'Statistiques de trafic',
      trafficStatsDescription: 'Aperçu des visites sur votre page d\'établissement',
      dateStart: 'Date de début',
      dateEnd: 'Date de fin',
      granularity: 'Granularité',
      day: 'Jour',
      week: 'Semaine',
      month: 'Mois',
      noTrafficData: 'Aucune donnée disponible pour la période sélectionnée',
      visits: 'Visites'
    },
    contacts: {
      addContact: 'Ajouter un contact',
      editContact: 'Modifier le contact',
      newContact: 'Nouveau contact',
      role: 'Fonction',
      selectRole: 'Sélectionner une fonction',
      name: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      mobile: 'Téléphone mobile',
      actions: 'Actions',
      noContacts: 'Aucun contact pour cet établissement',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce contact ?',
      deleteContact: 'Supprimer le contact',
      roles: {
        director: 'Directeur',
        secretary: 'Secrétaire',
        assistant: 'Assistant de direction',
        commercial: 'Conseiller commercial',
        regional: 'Directeur régional',
        other: 'Autre'
      }
    },
    housing: {
      addUnit: 'Ajouter un hébergement',
      editUnit: 'Modifier l\'hébergement',
      newUnit: 'Nouvel hébergement',
      type: 'Type',
      selectType: 'Sélectionner un type',
      units: 'Nombre d\'unités',
      area: 'Surface',
      price: 'Prix par mois',
      currency: 'Devise',
      notes: 'Notes',
      noUnits: 'Aucun hébergement configuré',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet hébergement ?',
      deleteUnit: 'Supprimer l\'hébergement',
      actions: 'Actions',
      typeRequired: 'Le type d\'hébergement est requis',
      unitsPositive: 'Le nombre d\'unités doit être supérieur à zéro'
    },
    features: {
      noCategories: 'Aucune catégorie de caractéristiques disponible pour votre pays',
      noCategoryFeatures: 'Aucune caractéristique dans cette catégorie',
      addNotes: 'Ajouter des notes (optionnel)',
      allCategories: 'Toutes les catégories'
    },
    media: {
      title: 'Médias',
      noMedia: 'Aucun média n\'a été ajouté',
      addMedia: 'Ajouter un média',
      mediaType: 'Type de média',
      altText: 'Texte alternatif',
      altTextPlaceholder: 'Description du média',
      file: 'Fichier',
      uploadFile: 'Télécharger un fichier',
      dragDrop: 'glisser-déposer',
      noAltText: 'Aucune description',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce média ?',
      mainMedia: 'Média principal',
      setAsMain: 'Définir comme média principal',
      delete: 'Supprimer'
    },
    documents: {
      title: 'Brochures',
      noDocuments: 'Aucune brochure n\'a été ajoutée',
      addDocument: 'Ajouter une brochure',
      name: 'Nom',
      namePlaceholder: 'Nom de la brochure',
      file: 'Fichier',
      uploadFile: 'Télécharger un fichier',
      dragDrop: 'glisser-déposer',
      viewDocument: 'Voir le document',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette brochure ?',
      delete: 'Supprimer'
    },
    leads: {
      title: 'Demandes de contact',
      loading: 'Chargement des demandes...',
      noLeads: 'Aucune demande de contact',
      markAsRead: 'Marquer comme lu',
      name: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      date: 'Date',
      actions: 'Actions',
      view: 'Voir',
      details: {
        title: 'Détails de la demande',
        urgencyDelay: "Délai d'urgence",
        searchReason: "Recherche effectuée pour",
        monthlyBudget: "Budget mensuel",
        searchArea: "Zone géographique",
        loadingGeo: "Chargement des informations géographiques...",
        loadingGeoShort: "Chargement...",
        geoNotFound: "Non trouvé",
        senior1: "Personne âgée 1",
        senior2: "Personne âgée 2",
        senior: "Personne âgée",
        lastName: "Nom",
        firstName: "Prénom",
        civility: "Civilité",
        age: "Âge",
        residencePostalCode: "CP de résidence",
        currentStayLocation: "Lieu de séjour actuel",
        currentPlace: "Lieu actuel",
        autonomyLevel: "Degré d'autonomie",
        cognitiveIssues: "Problèmes cognitifs"
      },
      back: 'Retour',
      message: 'Message',
      budget: 'Budget',
      couple: 'Couple',
      delay: 'Délai',
      person1: 'Personne 1',
      person2: 'Personne 2',
      fullName: 'Nom complet',
      age: 'Âge',
      autonomous: 'Autonome',
      geoSearch: {
        city: 'Ville de recherche : {name} {code} dans un rayon de {radius} km',
        department: 'Département de recherche : {name} {code}'
      },
      forFacility: 'pour'
    }
  },
  group: {
    title: 'Tableau de bord du groupe',
    groupUser: 'Utilisateur du groupe',
    groupManager: 'Gestionnaire du groupe',
    nav: {
      dashboard: 'Tableau de bord',
      facilities: 'Établissements',
      reporting: 'Reporting',
      leads: 'Demandes de contact'
    },
    facilities: {
      name: 'Nom',
      type: 'Type',
      location: 'Localisation',
      actions: 'Actions',
      view: 'Voir',
      forFacility: 'pour',
      list: 'Liste des établissements',
      loading: 'Chargement des établissements...',
      noFacilities: 'Aucun établissement trouvé',
      show: 'Afficher',
      to: 'à',
      of: 'sur',
      results: 'résultats',
      previous: 'Précédent',
      next: 'Suivant',
      viewPublicPage: 'Voir la page publique'
    },
    dashboard: {
      facilities: 'Établissements',
      totalLeads: 'Total des prospects',
      newLeads: 'Nouveaux prospects',
      trafficStats: 'Statistiques de trafic',
      trafficStatsDescription: 'Aperçu des visites sur vos pages d\'établissement',
      dateStart: 'Date de début',
      dateEnd: 'Date de fin',
      granularity: 'Granularité',
      day: 'Jour',
      week: 'Semaine',
      month: 'Mois',
      allFacilities: 'Tous les établissements',
      searchFacilityPlaceholder: 'Rechercher un établissement...',
      noTrafficData: 'Aucune donnée disponible pour la période sélectionnée',
      visits: 'Visites',
      latestLeads: 'Dernières demandes de contact',
      latestLeadsDescription: '100 dernières demandes de contact reçues'
    },
    reporting: {
      period: 'Période de reporting',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      totalContacts: 'Nombre de demandes reçues',
      mostContactedFacility: 'Établissement le plus contacté',
      averageContactsPerDay: 'Moyenne de contacts par jour',
      totalVisits: 'Nombre de visites',
      mostVisitedFacility: 'Établissement le plus visité',
      averageVisitsPerDay: 'Moyenne de visites par jour',
      facilitiesList: 'Liste des établissements',
      searchFacility: 'Rechercher un établissement...',
      contacts: 'contacts',
      visits: 'visites',
      showing: 'Affichage de',
      to: 'à',
      of: 'sur',
      results: 'résultats'
    },
    leads: {
      title: 'Demandes de contact',
      loading: 'Chargement des demandes...',
      noLeads: 'Aucune demande de contact',
      name: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      date: 'Date',
      facility: 'Établissement',
      actions: 'Actions',
      view: 'Voir',
      forFacility: 'pour',
      latestLeadsReceived: '{count} dernières demandes de contact reçues',
      unreadLeads: '{count} non lues',
      searchByNameOrEmailPlaceholder: 'Rechercher par nom ou email...'
    }
  },
  leadRightPanel: {
    tabActivity: 'Activité',
    tabOrientations: 'Orientations'
  },
  commercial: {
    title: 'Espace Commercial',
    commercialManager: 'Gestionnaire Commercial',
    dashboard: {
      title: 'Dashboard Commercial',
      leadsToProcess: 'Leads à traiter (Nouveau)',
      totalLeads: 'Nombre total de Leads',
      processedLeads: 'Nombre de leads traités',
      actionsTitle: 'Appels & Tâches à effectuer',
      overdue: 'En retard',
      today: 'Aujourd\'hui',
      future: 'Prochainement (10 prochaines)',
      noActions: 'Pas encore d\'action effectuée',
      taskLabel: 'Tâche',
      callLabel: 'Appel'
    },
    leads: {
      title: 'Gestion des leads',
      searchPlaceholder: 'Rechercher un nom, prénom, email...',
      searchButton: 'OK',
      advancedFiltersButton: 'Filtres avancés',
      groupStatus: {
        toProcess: 'À traiter',
        processed: 'Traités',
        closed: 'Clôturés',
        all: 'Tous'
      },
      filters: {
        status: 'Statut',
        commercial: 'Commercial',
        source: 'Source',
        dateFrom: 'Du',
        dateTo: 'Au',
        allStatuses: 'Tous les statuts',
        allCommercials: 'Tous les commerciaux',
        allSources: 'Toutes les sources'
      },
      table: {
        noLeadsFoundFilters: 'Aucun lead n\'a été trouvé. Vérifiez vos filtres ou rechargez la page.',
        noLeadsFoundSearch: 'Aucun lead ne correspond aux critères de recherche',
        headers: {
          name: 'Nom',
          phone: 'Téléphone',
          email: 'Email',
          source: 'Source',
          status: 'Statut',
          commercial: 'Commercial',
          date: 'Date',
          actions: 'Actions'
        }
      },
      actions: {
          viewDetailsTitle: 'Voir les détails',
          viewHistoryTitle: 'Voir l\'historique',
          assignCommercial: 'Assigner'
      },
      pagination: {
        previous: 'Précédent',
        next: 'Suivant',
        showingLeads: 'Affichage de {from} à {to} sur {total} leads',
        previousSr: 'Précédent',
        nextSr: 'Suivant'
      },
      historyModal: {
        title: 'Historique complet',
        closeSr: 'Fermer',
        noHistory: 'Aucun historique disponible',
        systemUser: 'Système',
        typeCommercial: 'Commercial',
        typeStatus: 'Statut'
      },
      errors: {
        loadFailed: 'Erreur lors du chargement des leads: {message}',
        loadGeneric: 'Une erreur est survenue lors du chargement des leads',
        statusUpdateFailed: 'Une erreur est survenue lors de la mise à jour du statut',
        assignFailed: 'Une erreur est survenue lors de l\'assignation du commercial'
      },
      history: {
        commercialPrefix: 'Commercial: ',
        noCommercial: 'Aucun commercial'
      }
    },
    map: {
      title: 'Carte des établissements',
      backToDashboard: 'Retour au Dashboard',
      searchFacilityPlaceholder: 'Rechercher un établissement...',
      searchCityPlaceholder: 'Rechercher une ville...',
      drawRadiusLabel: 'Tracer un rayon de',
      kmUnit: 'km',
      applyFilterButton: 'Appliquer',
      resetFilterButton: 'Réinitialiser',
      filterByTypeTitle: 'Filtrer par type :',
      noTypesToFilter: 'Aucun type à filtrer.',
      popup: {
        unknownName: 'Nom inconnu',
        groupLabel: 'Groupe: ',
        typesLabel: 'Type(s): '
      },
      errors: {
        selectCityFirst: 'Veuillez sélectionner une ville dans la liste avant d\'appliquer le filtre.',
        mapInstanceUnavailable: 'Erreur : Instance de carte non disponible.',
        cannotDetermineCountry: 'Impossible de déterminer le pays de l\'utilisateur.',
        errorLoadingLeadData: 'Erreur lors du chargement des données du lead.',
        validationError: 'Erreur lors de la validation des orientations:',
        realtimeError: 'Erreur de connexion temps réel'
      },
      leadInfoTitle: 'Informations du Lead',
      leadNameLabel: 'Nom:',
      leadEmailLabel: 'Email:',
      leadPhoneLabel: 'Téléphone:',
      leadDesiredTypeLabel: 'Type souhaité:',
      leadWishesLabel: 'Souhaits:',
      leadRadiusLabel: 'Éloignement possible:',
      orientationForLead: 'Orientation pour le lead',
      orientButton: 'Orienter',
      alreadyInBasket: 'Déjà dans les orientations',
      basketTitle: 'Orientations',
      basketEmpty: 'Pas d\'orientation disponible',
      validateButton: 'Valider les orientations',
      loadingComplete: 'Chargement terminé',
      facilityTypesCount: 'Types d\'établissements',
      facilitiesCount: 'Établissements',
      countryId: 'ID Pays',
      retryButton: 'Réessayer'
    },
    facilities: {
      title: 'Établissements',
      searchPlaceholder: 'Rechercher un établissement...',
      filterPaying: 'Filtrer par Payant',
      filterGroup: 'Filtrer par Groupe',
      filterType: 'Filtrer par Type',
      allGroups: 'Tous les Groupes',
      allTypes: 'Tous les Types',
      payingStatus: {
        all: 'Tous',
        yes: 'Payant',
        no: 'Non Payant'
      },
      listTitle: 'Liste des établissements',
      name: 'Nom',
      location: 'Localisation',
      group: 'Groupe',
      types: 'Types',
      paying: 'Payant',
      actions: 'Actions',
      view: 'Voir',
      noFacilities: 'Aucun établissement trouvé pour les critères sélectionnés.',
      pagination: {
        show: 'Afficher',
        showing: 'Affichage de {from} à {to} sur {total} établissements',
        previous: 'Précédent',
        next: 'Suivant',
        previousSr: 'Précédent',
        nextSr: 'Suivant'
      }
    },
    actions: {
      noActions: 'Pas encore d\'action effectuée',
      note: 'Note',
      appel: 'Appel',
      email: 'Email',
      task: 'Tâche',
      statuses: {
        programmed: 'Programmé',
        contacted: 'Joint',
        notContacted: 'Non Joint',
        todo: 'À faire',
        done: 'Fait',
        undefined: 'Non défini'
      },
      form: {
        addNote: 'Ajouter une note',
        addCall: 'Ajouter un appel',
        addEmail: 'Envoyer un email',
        addTask: 'Ajouter une tâche',
        editNote: 'Modifier une note',
        editCall: 'Modifier un appel',
        editEmail: 'Modifier un email',
        editTask: 'Modifier une tâche',
        sending: 'Envoi en cours...',
        save: 'Enregistrer',
        saveChanges: 'Enregistrer les modifications',
        add: 'Ajouter'
      },
      labels: {
        date: 'Date',
        status: 'Statut',
        by: 'Par',
        to: 'À',
        cc: 'Cc',
        bcc: 'Bcc',
        subject: 'Objet',
        from: 'De',
        user: 'Utilisateur',
        loading: 'Chargement...',
        markAsDone: 'Marquer comme fait',
        contactedCall: 'Appel Joint',
        notContactedCall: 'Appel Non Joint',
        noModels: 'Aucun modèle disponible',
        sharedModels: 'Modèles partagés',
        myModels: 'Mes modèles',
        loadingModels: 'Chargement des modèles...',
        noSubject: 'Sans objet',
        noRecipient: 'N/A',
        all: 'Tous',
        email: 'Email',
        call: 'Appel',
        note: 'Note',
        task: 'Tâche',
        addCall: 'Ajouter un appel',
        addNote: 'Ajouter une note',
        sendEmail: 'Envoyer un email',
        addTask: 'Ajouter une tâche'
      },
      confirmDelete: {
        title: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
        text: 'Êtes-vous sûr de vouloir supprimer cette {type} ?',
        cancel: 'Annuler',
        confirm: 'Supprimer'
      },
      history: {
        modified: 'Statut d\'appel modifié',
        new: 'Nouveau statut d\'appel',
        actionModified: 'Action modifiée',
        actionAdded: 'Action ajoutée',
        taskAdded: 'Tâche ajoutée',
        emailSent: 'Email envoyé',
        actionDeleted: 'Action supprimée',
        oldDate: 'Ancienne date',
        newDate: 'Nouvelle date',
        state: 'État',
        oldNote: 'Ancienne note',
        newNote: 'Nouvelle note',
        note: 'Note',
        description: 'Description',
        deadline: 'Échéance',
        content: 'Contenu',
        noContent: 'Aucun contenu'
      },
      delete: {
        confirmTitle: 'Supprimer une action',
        confirmMessage: 'Êtes-vous sûr de vouloir supprimer cette action ? Cette opération est définitive.',
        cancel: 'Annuler',
        confirm: 'Supprimer'
      },
      emailAction: {
        newMessage: 'Nouveau message',
        saveAsModel: 'Sauvegarder comme modèle',
        modelName: 'Nom du modèle',
        modelNamePlaceholder: 'Ex: Confirmation de réservation',
        columns: 'Colonnes',
        models: 'Modèles',
        insertColumn: 'Insérer une colonne',
        newModel: 'Nouveau',
        sent: 'Email envoyé',
        noSubject: 'Sans objet',
        send: 'Envoyer',
        requiredFields: 'Les champs destinataire et objet sont requis',
        template: {
          nameRequired: 'Veuillez saisir un nom pour le modèle',
          missingUserInfo: 'Informations utilisateur manquantes',
          saveError: 'Erreur lors de la sauvegarde'
        }
      },
      lead: {
        facilityNoteTitle: "Note pour l'établissement",
        saveNote: "Enregistrer la note",
        savingNote: "Enregistrement...",
        notFound: "Lead introuvable",
        errors: {
          statusUpdateFailed: "Une erreur est survenue lors de la mise à jour du statut.",
          saveFailed: "Erreur lors de la sauvegarde du nom."
        },
        parentOptionsLabels: {
          friend: 'Ami(e)',
          greatGrandchild: 'Arrière petit enfant',
          other: 'Autre',
          daughterInLaw: 'Belle fille',
          sisterInLaw: 'Belle sœur',
          partner: 'Concubin(e)',
          spouse: 'Conjoint',
          cousin: 'Cousin(e)',
          curator: 'Curateur',
          daughter: 'Fille',
          son: 'Fils',
          brother: 'Frère',
          sonInLaw: 'Gendre',
          agent: 'Mandataire',
          doctorOrganizations: 'Médecin - organismes',
          generalPractitioner: 'Médecin traitant',
          mother: 'Mère',
          nephew: 'Neveu',
          niece: 'Nièce',
          notary: 'Notaire',
          uncle: 'Oncle',
          father: 'Père',
          personItself: 'Personne elle-même',
          myself: 'Moi-même',
          grandchild: 'Petit-enfant',
          legalRepresentative: 'Représentant légal',
          sister: 'Sœur',
          aunt: 'Tante',
          guardian: 'Tuteur'
        },
        admissionOptionsLabels: {
          immediate: 'Immédiat',
          oneToThreeMonths: '1 à 3 mois',
          threeToSixMonths: '3 à 6 mois',
          moreThanSixMonths: '+ de 6 mois'
        }
      },
      leadElderly: {
        sectionTitle: 'Personnes âgées',
        addPersonButton: 'Ajouter une personne',
        editPersonTitle: 'Modifier les informations',
        ageLabel: 'Âge',
        currentStayLabel: 'Lieu de séjour actuel',
        currentStayOptions: {
          home: 'Domicile',
          healthFacility: 'Établissement de santé',
          family: 'En famille',
          careHome: 'En EHPAD / Foyer',
          other: 'Autre'
        },
        postalCodeLabel: 'Code postal domicile',
        postalCodePlaceholder: 'Entrez un code postal ou nom de ville',
        postalCodeSearching: 'Recherche en cours...',
        autonomyLabel: 'Autonomie',
        autonomyOptions: {
          valid: 'Valide',
          semiValid: 'Semi-Valide',
          dependent: 'Dépendant',
          veryDependent: 'Très dépendant'
        },
        cognitiveStateLabel: 'État cognitif',
        cognitiveStateOptions: {
          none: 'Aucun',
          little: 'Peu',
          advanced: 'Avancé',
          veryAdvanced: 'Très Avancé'
        },
        stayTypeLabel: 'Type de séjour',
        stayTypeOptions: {
          permanent: 'Permanent',
          temporary: 'Temporaire',
          shortStay: 'Court séjour'
        },
        editButtonTitle: 'Modifier',
        deleteButtonTitle: 'Supprimer',
        yearsSuffix: 'ans',
        displayLabels: {
          postalCode: 'Code postal:',
          currentLocation: 'Lieu actuel:',
          autonomy: 'Autonomie:',
          cognitiveState: 'État cognitif:',
          stayType: 'Séjour:'
        },
        alerts: {
          missingCountryIdError: 'country_id manquant pour le lead.',
          postalCodeSearchError: 'Erreur lors de la recherche de code postal.',
          postalCodeLoadError: 'Erreur lors du chargement des informations du code postal.',
          saveError: 'Une erreur est survenue lors de la sauvegarde',
          deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette personne ?',
          deleteError: 'Une erreur est survenue lors de la suppression'
        },
        noElderlyMessage: 'Aucune personne âgée renseignée',
        history: {
          addition: 'Ajout',
          modification: 'Modification',
          noPerson: 'Aucune personne',
          elderlyPerson: 'Personne âgée {index}',
          addedPerson: 'Ajout de la personne âgée: {personName}',
          modifiedPerson: 'Modification de la personne âgée: {personName}',
          deletedPerson: 'Suppression de la personne âgée {index}'
        }
      },
      leadLocalisation: {
        sectionTitle: 'Localisations souhaitées',
        deleteButtonTitle: 'Supprimer cette localisation',
        addLocationButton: 'Ajouter une localisation',
        searchInputPlaceholder: 'Chercher une ville, un département ou un code postal',
        suggestionGroupLabels: {
          departments: 'Départements',
          cities: 'Villes'
        },
        addingInProgress: 'Ajout en cours...',
        radiusLabel: 'Éloignement possible',
        desiredResidenceLabel: 'Résidence souhaitée',
        radiusOptions: {
          km0: '0 km',
          km10: '10 km',
          km20: '20 km',
          km30: '30 km',
          km40: '40 km',
          km50: '50 km',
          km80: '80 km',
          km100: '100 km',
          km150: '150 km'
        },
        alerts: {
          searchError: 'Erreur de recherche.',
          noSlotError: 'Aucun emplacement disponible pour ajouter une localisation.',
          addErrorConsole: 'Erreur lors de l\'ajout de la localisation.',
          addErrorAlert: 'Une erreur est survenue lors de l\'ajout de la localisation.',
          notFoundInLeadError: 'Localisation non trouvée dans le lead.',
          deleteErrorConsole: 'Erreur lors de la suppression de la localisation.',
          deleteErrorAlert: 'Une erreur est survenue lors de la suppression de la localisation.',
          updateFieldErrorConsole: 'Erreur lors de la mise à jour du champ.',
          updateFieldErrorAlert: 'Une erreur est survenue lors de la mise à jour.'
        }
      },
      loading: 'Chargement des activités...',
      noActivity: 'Aucune activité pour le moment.',
      editEmailNotImplemented: "L'édition d'email existant n'est pas encore implémentée avec le nouveau composeur.",
      deleteActionConfirm: 'Êtes-vous sûr de vouloir supprimer cette action ?',
      taskForm: {
        statusOptions: {
          todo: 'À faire',
          done: 'Fait'
        },
        errors: {
          loadUsersError: 'Impossible de charger la liste des utilisateurs',
          contentRequired: 'Le contenu de la tâche est requis',
          saveError: 'Erreur lors de la sauvegarde. Veuillez réessayer.'
        },
        loadingUsers: 'Chargement des utilisateurs...',
        titleEdit: 'Modifier la tâche',
        titleNew: 'Nouvelle tâche',
        statusLabel: 'Statut *',
        assignedToLabelTodo: 'À faire par *',
        assignedToLabelDone: 'Fait par *',
        unassigned: 'Non assigné',
        optgroupYou: 'Vous',
        optgroupUsers: 'Utilisateurs',
        userSuffixYou: '(vous)',
        dateTimeLabel: 'Date et heure *',
        descriptionLabel: 'Description de la tâche *',
        descriptionPlaceholder: 'Décrivez la tâche...',
        buttons: {
          cancel: 'Annuler',
          edit: 'Modifier',
          create: 'Créer'
        }
      }
    },
    leadHeader: {
      civilityLabel: 'Civilité',
      civilityPlaceholder: '--',
      civilityOptions: {
        mr: 'M.',
        mrs: 'Mme',
        ms: 'Mlle'
      },
      firstNameLabel: 'Prénom',
      lastNameLabel: 'Nom',
      dossierNumber: 'Dossier N°'
    },
    contactInfoTitle: 'Informations de contact',
    fieldLabelPhone: 'Téléphone',
    fieldLabelEmail: 'Email',
    fieldLabelDesiredFacilityType: "Type d'établissement souhaité",
    fieldLabelUnspecified: 'Non spécifié',
    fieldLabelParentLink: 'Lien de parenté',
    fieldLabelAdmissionDelay: "Délai d'admission",
    selectPlaceholder: 'Sélectionnez…',
    filterPlaceholder: 'Filtrer…',
    noResultsMessage: 'Aucun résultat',
    notCommunicatedShort: 'N.C.',
    creationDateLabel: 'Date de création',
    sourceLabel: 'Source',
    assignCommercialButtonLabel: 'Assigner'
  },
  // Traductions pour le composant MinimizedEmailComposer
  emailComposer: {
    newMessage: 'Nouveau message',
    noRecipient: 'Aucun destinataire',
    maximizeButtonTitle: 'Agrandir',
    closeButtonTitle: 'Fermer',
    name: 'Nom',
    email: 'Email',
    phone: 'Numéro de téléphone',
    creationDate: 'Date de création',
    myTemplates: 'Mes modèles',
    sharedTemplates: 'Modèles partagés',
    personalTemplates: 'Modèles personnels',
    saveAsTemplate: 'Sauvegarder comme modèle',
    templateName: 'Nom du modèle',
    templateNamePlaceholder: 'Ex: Confirmation de réservation',
    cancel: 'Annuler',
    save: 'Sauvegarder',
    selectTemplate: 'Sélectionner un modèle',
    new: 'Nouveau',
    loadingTemplates: 'Chargement des modèles...',
    noTemplatesAvailable: 'Aucun modèle disponible',
    templates: 'Modèles',
    columns: 'Colonnes',
    insertColumn: 'Insérer une colonne'
  },
  activityTask: {
    markAsDone: 'Marquer comme fait',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette tâche ?',
    editTitle: 'Modifier cette tâche',
    deleteTitle: 'Supprimer cette tâche',
    date: 'Date',
    status: 'Statut',
    by: 'Par'
  },
  activityNote: {
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette note ?',
    editTitle: 'Modifier cette note',
    deleteTitle: 'Supprimer cette note'
  },
  commercialTask: {
    taskForm: {
      unassigned: 'Non assigné'
    }
  },
  orientations: {
    missingOrientationAlert: "L'utilisateur a envoyé ce lead pour la résidence {facilityName} à {geoEntityName} ({geoEntityCode}), mais il n'y a pas d'orientation.",
    createOrientation: "Créer l'orientation",
    orientLead: "Orienter le Lead",
    searchFacility: "Rechercher un établissement à orienter",
    facilityNamePlaceholder: "Nom de l'établissement...",
    group: "Groupe",
    type: "Type",
    orient: "Orienter",
    orientFromMap: "Orienter depuis la carte",
    addingOrientation: "Ajout de l'orientation...",
    orientationsToValidate: "Orientations à Valider",
    checkAll: "Tout cocher",
    validate: "Valider {count} {count <= 1 ? 'orientation' : 'orientations'}",
    addedOn: "Ajouté le",
    deleteOrientation: "Supprimer cette orientation",
    sentOrientations: "Orientations Envoyées",
    noSentOrientations: "Aucune orientation envoyée.",
    sentOn: "Envoyé le",
    leadId: "ID Lead",
    deleteOrientationAndLead: "Supprimer cette orientation et le lead associé (si non traité)",
    confirmationRequired: "Confirmation requise",
    emptyNoteWarning: "La note pour l'établissement est vide. Merci de la renseigner avant de valider les orientations."
  },
  taskForm: {
    new: 'Nouvelle tâche',
    edit: 'Modifier la tâche',
    status: {
      todo: 'À faire',
      done: 'Fait',
      undefined: 'Non défini'
    },
    statusLabel: 'Statut',
    assignedTodo: 'À faire par',
    assignedDone: 'Fait par',
    loadingUsers: 'Chargement des utilisateurs...',
    you: 'Vous',
    users: 'Utilisateurs',
    dateTime: 'Date et heure',
    description: 'Description de la tâche',
    descriptionPlaceholder: 'Décrivez la tâche...',
    saveError: 'Erreur lors de la sauvegarde. Veuillez réessayer.'
  },
  activityForm: {
    modify: 'Modifier',
    add: 'Ajouter',
    note: 'une note',
    email: 'un email',
    call: 'un appel',
    task: 'une tâche',
    sending: 'Envoi en cours...',
    saveChanges: 'Enregistrer les modifications',
    requiredFields: 'Veuillez remplir tous les champs obligatoires',
    emptyContent: 'Le contenu ne peut pas être vide.',
    date: 'Date',
    time: 'Heure',
    status: 'Statut',
    content: 'Contenu',
    noteT: 'Note',
    taskN: 'Tâche',
    selectCommercial: 'Sélectionnez un commercial',
    you: '(vous)',
    callStatus: {
      scheduled: 'Programmé',
      contacted: 'Joint',
      notContacted: 'Non joint'
    },
    callState: 'État de l\'appel',
    assignedTo: 'Assigné à',
    callNotePlaceholder: 'Écrivez votre note d\'appel ici (optionnelle)...',
    contentPlaceholder: 'Écrivez votre contenu ici...',
    loadingCommercials: 'Chargement des commerciaux...'
  },
  emailComposerForm: {
    sharedTemplates: 'Modèles partagés',
    templates: 'Modèles',
    columns: 'Colonnes',
    insertColumn: 'Insérer une colonne'
  }
}